module.exports = __webpack_public_path__ + "files/4fe5454932fa692613af04e2db6c9909.png";